/**
 * VERSIONE LIBRERIA 3
 */
var RenderSwap = Render.extend({
    type : 'swap',
    classData : 'swap',
    classTemplate : 'swap',
    classTrue : "text-success",
    classFalse : "text-danger",
    title : 'Attiva/Disattiva',
    domaniValues : null,

    _setHtmlData :function(jQe) {
        var self = this;
        var el = jQe.find(self.control_selector);
        el.attr('title',self.title);
        if (!self.domaniValues) {
            if (self.value === true || self.value === false) {
                if (self.value) {
                    jQe.find('i').removeClass(self.classFalse);
                    jQe.find('i').addClass(self.classTrue);
                } else {
                    jQe.find('i').removeClass(self.classTrue);
                    jQe.find('i').addClass(self.classFalse);
                }
            } else {
                if (parseInt(self.value)) {
                    jQe.find('i').removeClass(self.classFalse);
                    jQe.find('i').addClass(self.classTrue);
                } else {
                    jQe.find('i').removeClass(self.classTrue);
                    jQe.find('i').addClass(self.classFalse);
                }
            }
            return ;
        }
        jQe.find('i').removeClass(self.classFalse);
        jQe.find('i').addClass(self.classTrue);

        var values = _.keys(self.domainValues);
        if (values.length <= 2) {
            log.warn("domain values lenght < 2");
            return ;
        }
        var txt = self.domainValues[values[0]];
        if (self.value == values[1]) {
            txt = self.domainValues[values[1]];
            jQe.find('i').addClass(self.classFalse);
            jQe.find('i').removeClass(self.classTrue);
        }
        jQe.find('i').html('&nbsp;'+txt);

    },
    _renderView : function (jQe) {
        this.value = parseInt(this.value);
        this._setHtmlData(jQe);
    },
    _renderEdit : function (jQe) {
        this._setHtmlData(jQe);
    },
    _finalizeEdit : function() {
        var self = this;
        var jQe = $(self.container);
        var el = jQe.find(self.control_selector);
        el.click(function () {


            if (! self.domainValues ) {
                if (self.value === true || self.value === false) {
                    self.value = ! self.value;
                } else
                    self.value = parseInt(self.value) == 1?0:1;
            } else {
                var values = _.keys(self.domainValues);
                if (self.value == values[0])
                    self.value = values[1];
                else
                    self.value = values[0];
            }
            //log.debug("To " , self.data.value);
            self._setHtmlData(jQe);
            self._emitEvent('change',self.value);
        })
    },
    _finalizeView : function(){},
    getValue : function () {
        return this.value;
    }
});